import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { AccountProfileService } from '../../../app/accountProfile/accountProfile.service';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { ProviderportalService } from '../providerportal.service';
import { TrainingMaterialService } from './trainingmaterial.service';
//import { PDFDocument } from 'pdf-lib'
import { Observable,zip, from , combineLatest, forkJoin } from 'rxjs';
import { HeaderService } from '../../header/header.service';
import { SecureStorageService } from '../../secure-storage.service';
import { PDFDocument } from 'pdf-lib';
import {Modal} from 'bootstrap';

@Component({
    selector: 'app-provider-training',
    templateUrl: './provider-training.component.html',
    styleUrls: ['./provider-training.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class ProviderTrainingComponent implements OnInit, AfterViewInit {
  isinit = false;
  isPdfLoaded = false;
  ngAfterViewInit(): void {
    if (!this.isinit) {
    }
    this.isinit = true;
  }
  MAIL_FORMAT = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$';

  taxId = null;
  data = [];
  sites: any[] = [];
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  showSpinner = false;
  selectedSite: any;
  pcpDropdownforDCE: boolean = false;
  public showCollapseAll: boolean = false;
  public sitePlaceHolder: string;
  providers: any[] = [];
  providersList: any[] = [];
  providersListdropdownOptions:any[] = [];
  pcpChanged: boolean;
  showProviders = false;
  diseasesList: Array<any> = [];
  dropdownSettings = {};
  loading = false;
  userName: any;
  userData: any = {};
  pcpTable: boolean = false;
  selectedPCP = [];
  filteredItem: any = [];
  step = 'details';

  docs = [];
  pdfviewtab: boolean = false;
  dateon: boolean = false;
  pdfSource: any;
  currentDateTime = '';
  completed: boolean = false;
  trainingLinks = [
    {
      id: 'hipaa-training',
      name: 'HIPAA Training',
      link: 'https://www.hhs.gov/hipaa/for-professionals/training/index.html',
      readTimestamp: null,
    },
    {
      id: 'cultural-competency-training',
      name: 'Cultural Competency (TGI) Training Program',
      link: 'https://rise.articulate.com/share/dOQPG7k_nX53O1U9s6W0DIgeiEwJp3oC',
      readTimestamp: null,
    }
  ];
  isInternalUser: boolean;
  agreeAttest = false;
  agreeTerms = false;
  mergedPdf = null;
  completeTrainingAlertMsg = `We will not save your progress, please complete all the trainings associated with the selected providers before you exit.`;
  pdfViewLink: any;

  pdfViewShow = false;
  loadInternalUserSiteSubscription: any;
  sitesData: any;
  handleResults(searchObj) {
    this.data = searchObj;
  }

  constructor(
    private router: Router,
    private cupService: CupService,
    private urlconstantsService: UrlconstantsService,
    private accountProfileService: AccountProfileService,
    private providerPortalervice: ProviderportalService,
    private trainingMaterialService: TrainingMaterialService,
    public datepipe: DatePipe,
    private secureStorage: SecureStorageService,
    private headerService: HeaderService
  ) {}

  ngOnInit() {
    //  setTimeout(()=>{
    this.init();

    //  },100)
  }
  init() {
    this.getChart();

    this.step = 'details';
    // const userDetails = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('userProfile'));
    // //console.log(userDetails)
    // this.userName = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('currentUser'))['userName'];
    this.userName = this.cupService.getUserNameFromJWT();
    this.isInternalUser = this.cupService.isInternalUser();
    const o1 = this.getExternalDashboard();
    const o2 = this.getPCPProviders();
    const o3 = this.getUserData();

    const zip2 = zip(o1, o2, o3);

    zip2.subscribe(
      (res) => {
        this.externalDashboarSubscribe(res[0]);
        this.pcpProvidersSubscribe(res[1]);
        this.userDataSubscribe(res[2]);
        this.showSpinner = false;
      },
      (err) => {
        this.showSpinner = false;
      }
    );
    this.showSpinner = true;

    this.filteredItem = [];
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select Physician',
      idField: 'providerId',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      badgeShowLimit: 1,
      maxHeight: 150,
      //classes:"myclass custom-class"
    };
  }
  getChart() {
    // this.openModal('previewChart');
  }

  pcpAllSites = [];

  async pcpProvidersSubscribe(siteData) {
    let checkDuplicates = [];
    this.sitesData = siteData;
    if (siteData && siteData.length) {
      for (const each of siteData) {
        let providerSiteInfo = await this.providerPortalervice.getProviderSiteInfo(each.siteUid).toPromise();
        //console.log("providerSiteInfo----:",providerSiteInfo);
          let contrcheck = [];
          let noNcontrcheck = [];
        
        if (each.providers && each.providers.length > 0) {
          let providerIds = [];
          for (const element of each.providers) {
            if (element.region.indexOf('OBSOLETE') === -1) {
              // Check if provider is contracted
              let isContracted = false;
              if (providerSiteInfo && providerSiteInfo.siteProviders && providerSiteInfo.siteProviders.length > 0) {
                const siteProvider = providerSiteInfo.siteProviders.find(sp => sp.providerId === element.providerId);
                //console.log("Total siteProvider 1 ----:",siteProvider)
                if (siteProvider && siteProvider.providerStatus === 'Contracted') {
                  isContracted = true;
                  contrcheck.push(siteProvider.providerId);
                  //console.log("isContracted true---:",contrcheck)
                }
                else{
                  noNcontrcheck.push(siteProvider.providerId)
                }
              }

              if (isContracted) {
              element.value =
                element.name +
                '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                element.region +
                '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                element.address.substring(0, 14);
              element.providerUid = element.id;
              element.id = element.providerId;
              if (!checkDuplicates.includes(element.value)) {
                checkDuplicates.push(element.value);
                // this.providers.push(element);
              }
                if (!providerIds.includes(element.providerId)) {
                  providerIds.push(element.providerId);
                }
              }
            }
          }
          ////console.log(this.providers)
          this.pcpAllSites.push({
            value: { id: each.siteUid, value: each.name },
            uid: providerIds,
          });
        }
              // console.log("contrcheck--:",contrcheck);
              // console.log("noNcontrcheck--:",noNcontrcheck);
      }
    } else {
      this.diseasesList = [];
    }
    this.showProviders = true;
  }

  getPCPProviders() {
    // this.providers = [];
    // this.activatedMenu = this.items[0];
    const userNameFromToken = this.cupService.getUserNameFromJWT();
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders.replace(
      '{id}',
      userNameFromToken
    );

    return this.cupService.retrieveData('post', siteDetailURL);
  }

  userDataSubscribe(userData) {
    if (userData && userData.length > 0) {
      this.userData = userData[0];
    }
  }
  getUserData() {
    return new Observable((subscriber) => {
      this.accountProfileService.getUserProfile(
        this.userName,
        (success: boolean, data) => {
          const d = [];
          if (success) {
            //////console.log("printing User data : ", data)
            let obj: any = {};
            (obj.firstName = data['firstName']),
              (obj.lastName = data['lastName']),
              (obj.middleName = data['middleName']),
              (obj.email = data['email']),
              (obj.phone = data['phone']),
              (obj.addressLine1 = data['addressLine1']),
              (obj.city = data['city']),
              (obj.state = data['state']),
              (obj.zip = data['zip']),
              d.push(obj);
            subscriber.next(d);
          }
        }
      );
    });
  }

  onPhoneKeyUp(event: any) {
    const inputValue: string = event.target.value;
    const numberValue = this.extractNumber(inputValue);
    const formattedPhone = this.constructPhoneFormat(numberValue);
    //this.model[event.target.name] = formattedPhone;
    event.target.value = formattedPhone;
  }

  extractNumber(value: string) {
    let newVal = '';
    if (isNaN(Number(value))) {
      for (let i = 0; i < value.length; i++) {
        const s: string = value.charAt(i);
        if (!isNaN(Number(s)) && s !== ' ') {
          newVal += s;
        }
      }
    } else {
      newVal = value;
    }
    return newVal;
  }

  constructPhoneFormat(value: string) {
    let newVal = value;
    if (value.length >= 4) {
      newVal = '(' + value.substring(0, 3) + ')';
      newVal += ' ' + value.substring(3, value.length <= 6 ? value.length : 6);
      if (value.length > 6) {
        newVal +=
          '-' + value.substring(6, value.length <= 10 ? value.length : 10);
      }
    }
    return newVal;
  }

  decimalRestrict(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  externalDashboarSubscribe(data: any) {
    if (data != null) {
      // this.sites = data.sites;
      if (data.sites && data.sites.length) {
        data.sites.map((element) => {
          this.sites.push({
            id: element.siteUid,
            value: element.siteName,
            label: element.siteName,
          });
        });
      }
    }
  }

  getExternalDashboard() {
    this.sites = [];
    //this.pcpscorecard = false;
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard;
    return this.cupService.retrieveData('post', url);
  }

  validateForm() {
    const email = this.userData.email;
    const phone = this.userData.phone;
    ////console.log('mail format',email.match(new RegExp(this.MAIL_FORMAT)))
    return !!email && !!phone && !!email.match(new RegExp(this.MAIL_FORMAT));
  }

  canGoNext() {
    let finalProviderInfo = [...this.filteredItem];
    finalProviderInfo = finalProviderInfo.filter(
      (singleProvider) => singleProvider.attestedDocId == undefined
    );
    return this.selectedPCP.length > 0 && finalProviderInfo.length > 0;
  }

  setProviders(e) {
    this.pcpTable = false;
    this.selectedSite = e;
    if (e.value === 'DCE-CMMI Providers') {
      this.pcpDropdownforDCE = true;
      this.openModal('CMMIDCEMessageModal');
    }
    this.showCollapseAll = false;
    this.sitePlaceHolder = '';
    this.providers = [];
    this.providersList = [];
    // if (this.isInternalUser) {
    //   this.setInternalProviders();
    // } else {
    this.setExternalProviders();
    // }
  }

  goToPage(): void {
    this.docs = [];
    this.getDocuments();
    this.step = 'attestation';
    this.openModal('completeTrainingAlert');
  }

  btnClick = function () {
    this.router.navigateByUrl('/user');
  };

  providerDetails() {
    this.pcpTable = true;
  }

  onChangeAgree() {
    this.agreeAttest = this.isCompletedTraining()
      ? !this.agreeAttest
      : this.agreeAttest;
  }

  onCheckTerms() {
    this.agreeTerms = !this.agreeTerms;
  }

  setExternalProviders() {
    this.providers = [];
    this.providersList = [];
    this.selectedPCP = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    let index = 0;

    const attestedProviderIdsObs =
      this.providerPortalervice.getAttestedProviders(this.userName);

    combineLatest(
      this.cupService.retrieveData('get', siteDetailURL),
      attestedProviderIdsObs,
      this.providerPortalervice.getProviderSiteInfo(this.selectedSite.id)
    ).subscribe(
      ([siteData, attestedIdsResp2,providerSiteInfo]) => {
        let attestedIdsResp: any = attestedIdsResp2;
        if (siteData) {
          const attestations =
            attestedIdsResp && attestedIdsResp.responseDatasArray
              ? attestedIdsResp.responseDatasArray[0].attestations
              : [];
          const attestedIdsMap = {};

          attestations.map((val) => {
            attestedIdsMap[val.taxId + ''] = val;
          });
          ////console.log(attestedIdsMap)

          //////console.log("siteData :",siteData)
          //if (siteData.siteProviderConfig && !(_.isEmpty(siteData.siteProviderConfig))) {
          if (
            siteData.siteProviderConfig &&
            siteData.siteProviderConfig != null
          ) {
            //  this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map((element) => {
              if (
                element.neighborhood &&
                element.region.indexOf('OBSOLETE') === -1
              ) {
                // Check termDate and NPI from sitesData
                let hasValidTermDateAndNpi = false;
                this.sitesData.forEach(singleSite => {
                  if (singleSite.providers) {
                    singleSite.providers.forEach(siteProvider => {
                      if (siteProvider.providerId == element.providerId) {
                        let termDate = new Date(siteProvider.termDate);
                        if (termDate.getTime() >= new Date().getTime() && siteProvider.npi && !isNaN(Number(siteProvider.npi))) {
                          hasValidTermDateAndNpi = true;
                        }
                      }
                    });
                  }
                });

                if (hasValidTermDateAndNpi) {
                  let isContracted = false;
                  if (providerSiteInfo && providerSiteInfo.siteProviders && providerSiteInfo.siteProviders.length > 0) {
                    const siteProvider = providerSiteInfo.siteProviders.find(sp => sp.providerId === element.providerId);
                    if (siteProvider && siteProvider.providerStatus === 'Contracted') {
                      isContracted = true;
                    }
                  }
                  if (isContracted) {
                    element.value =
                      element.name +
                      '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                      element.region +
                      '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                      element.address.substring(0, 14);
                    element.providerUid = element.id;
                    element.id = element.providerId;
                    let taxID = ''
                    this.sitesData.forEach(singleSite => {
                      if (singleSite.providers) {
                        singleSite.providers.forEach(siteProvider => {
                          if (siteProvider.providerId == element.providerId && new Date(siteProvider.termDate) > new Date()) {
                            taxID = siteProvider.npi;
                          }
                        })
                      }
                    });

                    if (!checkDuplicates.includes(taxID)) {
                      checkDuplicates.push(taxID);
                      const attestation = attestedIdsMap[taxID];

                      this.providers.push({
                        name: element.name,
                        providerId: element.providerId,
                        neighborhood: element.neighborhood,
                        region: element.region,
                        disabled: false,
                        taxId: taxID,
                        attestedDocId: attestation && attestation.docId,
                        createdDate: attestation && attestation.date,
                      });
                      const suffix =
                        attestation && attestation.docId ? ' (Attested)' : '';
                      ////console.log(suffix)
                      const itemName = element.name + '' + suffix;
                      ////console.log(itemName)
                      this.providersList.push({
                        id: index,
                        itemName: itemName,
                        disabled: false,
                        taxId: taxID,
                        providerId: element.providerId,
                        attestedDocId: attestation && attestation.docId,
                        createdDate: attestation && attestation.date,
                      });
                    }
                    index++;
                    this.providersListdropdownOptions = this.providersList;
                  }
                }
                
              }
            });
          } else {
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
        ////console.log("providers :", this.providers);
        ////console.log("providers List :", this.providersList);
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }

  onItemSelect(item: any) {
    ////console.log(item);
    ////console.log("this.selectedPCP.length---1 :", this.selectedPCP)
    this.dropdownfilterPCP();
  }
  OnItemDeSelect(item: any) {
    //////////console.log(item);
    ////console.log("this.selectedPCP.length---2 :", this.selectedPCP)
    if (this.selectedPCP.length === 0) {
      this.onDeSelectAll('');
    } else {
      this.dropdownfilterPCP();
    }
  }
  onSelectAll(items: any) {
    ////console.log("this.selectedPCP.length---3 :", this.selectedPCP)
    //////////console.log(items);
    this.dropdownfilterPCP();
  }

  onDeSelectAll(items: any) {
    ////console.log("this.selectedPCP.length---4 :", this.selectedPCP)
    this.dropdownfilterPCP();
  }

  dropdownfilterPCP() {
    ////console.log("dropdownfilterPCP -----")
    this.pcpTable = false;
    const selected = [];
    if (this.selectedPCP.length !== 0) {
      let result = this.selectedPCP.filter((item) => {
        this.providers.map((element) => {
          //////////console.log("printing element :",element,element.status)
          if (!element.disabled && element.taxId == item.taxId) {
            selected.push(element);
          }
        });
      });
    }

    this.filteredItem = selected;
    ////console.log(this.sitesData);
    // this.filteredItem.forEach(singleItem => {
    //   if(singleItem.providerId){
    //     this.sitesData.forEach(singleSite => {
    //       if(singleSite.providers){
    //         singleSite.providers.forEach(siteProvider =>{
    //           if(siteProvider.providerId == singleItem.providerId){
    //             singleItem.taxId = siteProvider.npi;
    //           }
    //         })
    //       }
    //     });
    //   }
    // });

    ////console.log("filteredItem ---:", this.filteredItem);
  }

  getDocuments() {
    const kvpl = [{ key: "isSigned", value: false }]
    this.showSpinner = true;
    // this.filteredItem.map(it => {
      // kvpl.push({ key: "ProviderID", value: it.providerId })
      // kvpl.push({ key: "isSigned", value: false })
      //  kvpl.push({key : 'ProviderName', value: it.name})
      //  kvpl.push({key : 'CreatedUser', value: 'mdemo019'})
      //  kvpl.push({key : 'NPI', value: "null"})
      //kvpl.push({key : 'AttachmentType', value: "application/pdf"})
      //    kvpl.push( {

      //     "value": "Internal Medicine",

      //     "key": "Specialty"

      //   })
      //   kvpl.push(
      //     {
      //     "value": "Contracting, Claims / Billing",

      //     "key": "OutreachType"

      //   })
      //   kvpl.push({

      //     "value": "Email,Fax",

      //     "key": "InteractionType"

      //   })
    // });

    this.trainingMaterialService.listDocuments(kvpl).subscribe(
      (data) => {
        const doc = <any>data;
        const list = doc.keyValuePairListWrapperlist;
        ////console.log(doc);
        if (!list || list.length <= 0) {
          return;
        }

        list.map((val) => {
          const { keyvaluePairWr } = val;
          const kvMap = {};
          keyvaluePairWr.map((it) => {
            kvMap[it.key] = it.value;
          });
          if (kvMap['DocumentTitle'] != 'New Provider Orientation') {
            this.docs.push({
              name: kvMap['DocumentTitle'],
              code: kvMap['Id'],
              readTimestamp: null,
            });
          }
        });
        this.completed = this.isCompletedTraining();
        ////console.log(this.completed)
        this.showSpinner = false;
      },
      (err) => {
        alert('Error Occurred');
        this.showSpinner = false;
      }
    );
  }

  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  viewPdf(attestedDocId) {
    this.showSpinner = true;
    this.trainingMaterialService
      .getWorkFlowDocument(attestedDocId, 'PROV_DOC')
      .subscribe(
        (responseData) => {
          if (responseData) {
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
              const blob = this.binary64ToBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              saveAs(blob, responseData.filename);
            } else {
              const blob = this.b64toBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              const urlBlob = URL.createObjectURL(blob);
              this.pdfViewLink = urlBlob;
              this.pdfViewShow = true;
            }
            this.showSpinner = false;
          }
        },
        (err) => {
          this.showSpinner = false;
        }
      );
  }

  goBackFromPdfView() {
    this.pdfViewLink = null;
    this.pdfViewShow = false;
  }
  goToPdf(item) {
    this.showSpinner = true;
    this.isPdfLoaded = false;
    if (item.link) {
      this.pdfSource = item;
      this.pdfviewtab = true;
      this.showSpinner = false;

      return;
    }
    this.trainingMaterialService
      .getWorkFlowDocument(item.code, 'PROV_DOC')
      .subscribe(
        (responseData) => {
          if (responseData) {
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
              const blob = this.binary64ToBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              saveAs(blob, responseData.filename);
              this.showSpinner = false;
            } else {
              const blob = this.b64toBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              const urlBlob = URL.createObjectURL(blob);
              ////console.log(urlBlob)
              const f = this.docs.find((val) => val.code == item.code);
              f.link = urlBlob;
              f.base64 = responseData.docContent;

              this.pdfSource = f;
              this.pdfviewtab = true;
              this.showSpinner = false;
            }
          } else {
            this.showSpinner = false;
          }
        },
        (err) => {
          this.showSpinner = false;
        }
      );

    ////console.log(item)
  }

  onPdfLoadProgress(evt) {
    this.showSpinner = true;
  }

  onPdfLoadComplete(evt) {
    setTimeout(() => {
      this.isPdfLoaded = true;
      this.showSpinner = false;
    }, 500);
  }

  goToLink(item) {
    const currentDateTime = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    const f = this.trainingLinks.find((val) => val.id == item.id);
    f.readTimestamp = currentDateTime;
    this.trainingLinks = this.trainingLinks.map((val) => val);
    this.completed = this.isCompletedTraining();
  }

  isCompletedTraining() {
    //return true;
    return (
      this.docs.findIndex(
        (it) =>
          (it.readTimestamp == null || it.readTimestamp == undefined) &&
          it.name != 'blob'
      ) < 0 &&
      this.trainingLinks.findIndex(
        (it) => it.readTimestamp == null || it.readTimestamp == undefined
      ) < 0
    );
  }

  backToTraining() {
    this.pdfviewtab = false;
    this.dateon = true;
    const currentDateTime = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    const current = this.pdfSource;
    const newData = this.docs.map((val) => val);
    const ch = newData.find((it) => it.code == current.code);
    ch.readTimestamp = currentDateTime;

    ////console.log(this.completed)
    this.docs = newData;
    this.completed = this.isCompletedTraining();
    ////console.log(this.completed)
    ////console.log(this.agreeAttest)
    this.agreeTerms = false;
  }

  goToBack($myParam: string = ''): void {
    const navigationDetails: string[] = ['/providerportal/provider-training'];
    if ($myParam.length) {
      navigationDetails.push($myParam);
    }
    this.router.navigate(navigationDetails);
  }

  async addPages(v, finalPdf) {
    if (v.base64 && v.readTimestamp) {
      ////console.log(v.base64)
      const pdf1 = await PDFDocument.load(v.base64);
      ////console.log("loaded ")
      ////console.log(pdf1.getPageIndices())
      const copiedPagesA = await finalPdf.copyPages(
        pdf1,
        pdf1.getPageIndices()
      );
      copiedPagesA.forEach((page) => finalPdf.addPage(page));
    }
  }

  async mergePdfs() {
    const finalPdf = await PDFDocument.create();
    for (const v of this.docs) {
      await this.addPages(v, finalPdf);
    }
    const mergedPdfFile = await finalPdf.saveAsBase64();
    ////console.log(mergedPdfFile)
    const blob = this.b64toBlob(mergedPdfFile, 'application/pdf', 512);
    const urlBlob = URL.createObjectURL(blob);

    return {
      urlBlob: urlBlob,
      file: blob,
    };
  }

  handleSubmit(): void {
    this.showSpinner = true;
    let finalProviderInfo = [...this.filteredItem];
    finalProviderInfo = finalProviderInfo.filter(
      (singleProvider) => singleProvider.attestedDocId == undefined
    );
    const payload = {
      docIds: this.docs.map((val) => val.code),
      user: {
        phone: this.userData.phone,
        email: this.userData.email,
      },
      providers: finalProviderInfo,
    };
    // payload.providers.map(v => v.providerId = v.taxId);
    ////console.log(payload);

    const taxIdChunks = this.chunkArray(payload.providers.map(v => v.taxId), 20);
    const providerIdChunks = this.chunkArray(payload.providers.map(v => v.providerId), 20);
    const providerNameChunks = this.chunkArray(payload.providers.map(v => v.name), 20);
    
   
const observableFrom$ = from(this.mergePdfs());
observableFrom$.subscribe((merged: any) => {
  ////console.log("merged", merged);


  const processChunk = (index: number) => {
    if (index >= taxIdChunks.length) {
      this.checkForTrainings();
      this.openModal('trainingSubmissionModal');
      this.showSpinner = false;
      return;
    }

    const taxIdJoin = taxIdChunks[index].join(',');
    const providerIdJoin = providerIdChunks[index].join(',');
    const providerNameJoin = providerNameChunks[index].join(',');
    const chunkPayload = {
      ...payload,
      providers: payload.providers.slice(index * 20, (index + 1) * 20),
      docIds: [] // Reset docIds for each chunk
    };

    this.trainingMaterialService.uploadFile(merged.file, [
      { key: "isSigned", value: true },
      { key: 'NPI', value: taxIdJoin },
      { key: 'ProviderID', value: providerIdJoin },
      { key: 'ProviderName', value: providerNameJoin }
    ]).subscribe((response: any) => {
      const docId = response.AddDocResponse.docId;
      if (docId) {
        chunkPayload.docIds = [docId];
        const submitObservable = this.providerPortalervice.submitTraining(chunkPayload);
        submitObservable.subscribe(() => {
          processChunk(index + 1); // Process the next chunk
        }, error => {
          this.showSpinner = false;
        });
      } else {
        this.showSpinner = false;
      }
    }, error => {
      this.showSpinner = false;
    });
  };

  processChunk(0); // Start processing the first chunk
}, error => {
  this.showSpinner = false;
});

  }
   chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
  async checkForTrainings(){
    const usernameFromToken = this.cupService.getUserNameFromJWT();
    this.showSpinner =true
    // const usernameFromToken = this.cupService.getUserNameFromJWT();
    let  urlConstant: any = this.urlconstantsService.fetchUrl();
    let attestedIds = []
    const siteDetailURL = urlConstant.userSiteProviders.replace(
      '{id}',
      usernameFromToken
    );
    
    let providerData$ =  this.cupService.retrieveData('post', siteDetailURL);
    let attestedIds$ =this.providerPortalervice.getAttestedProviders(this.userName)
    let zip2 = zip(providerData$,attestedIds$);
    zip2.subscribe(async res =>{
      
     let attestedIdsList = (res[1] && res[1].responseDatasArray) ? res[1].responseDatasArray[0].attestations : [];
     attestedIds = attestedIdsList.map(x=>x.taxId)
      let siteData = res[0];
      let providerIds = new Set();
      if (siteData && siteData.length) {

        for (const each of siteData) {
          let providerSiteInfo = await this.providerPortalervice.getProviderSiteInfo(each.siteUid).toPromise();
          //console.log(providerSiteInfo);
          
          if (each.providers && each.providers.length > 0) {
            for (const element of each.providers) {
              if (element.region.indexOf('OBSOLETE') === -1) {
                let termDate = new Date(element?.termDate)
                if(termDate.getTime()>= new Date().getTime()){
                  // Check if provider is contracted before adding NPI
                  let isContracted = false;
                  if (providerSiteInfo && providerSiteInfo.siteProviders && providerSiteInfo.siteProviders.length > 0) {
                    const siteProvider = providerSiteInfo.siteProviders.find(sp => sp.providerId === element.providerId);
                    if (siteProvider && siteProvider.providerStatus === 'Contracted') {
                      isContracted = true;
                    }
                  }
                  if (isContracted) {
                    providerIds.add(element.npi);
                  }
                }
              }
            }
          }
        }
        let isTrainingCompleted2 = Array.from(providerIds).every(e => attestedIds.includes(e));
        if(isTrainingCompleted2){
          //console.log("inside flag value for training and attestation")
          this.headerService.hideMenuSubject.next(false)
        }
        this.showSpinner = false;
      }
    },err=>{
    this.showSpinner =false

    })
  }
    
  handleBack(): void {
    this.step = 'details';
    this.trainingLinks.map((val) => {
      val.readTimestamp = null;
    });
    this.docs = [];
    this.agreeAttest = false;
  }

  handleModal(action): void {
    this.closeModal('trainingSubmissionModal');
    if (action == 'home') {
      this.router.navigateByUrl('providerportal/portal');
    } else if (action == 'search') {
      this.router.navigateByUrl('providerportal/provider-training');
      this.selectedSite = undefined;
      this.selectedPCP = [];
      this.pcpTable = false;
      this.filteredItem = [];
      this.handleBack();
      // this.getExternalDashboard();
    } else {
      this.router.navigateByUrl('providerportal/provider-training');
    }
  }
  openModal(modalId: any) {
    const modal = new Modal(document.getElementById(modalId));
    if(modal!=null){
      modal.show();
    }
   
  }
  closeModal(modalId: any) {
    const modalElement = document.getElementById(modalId);
    const modal = Modal.getInstance(modalElement);
    if(modal!=null){
      modal.hide();
    }
  }
}
